import { render, staticRenderFns } from "./FormsQueueHistory.vue?vue&type=template&id=8cfb3cde"
import script from "./FormsQueueHistory.vue?vue&type=script&lang=js"
export * from "./FormsQueueHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports